export default {
  subscription: require('./list').default,
  invoice: require('./history-invoice').default,
  detailInvoice: require('./detail-invoice').default,
  upgrade: require('./upgrade').default,
};
